import key from "../config/config";
import * as api from "../routes/userroutefront";
import axios from "../config/axios";
import { SET_GAME_DATA, SET_ODDS_DATA } from "../constants";
import { refreshWalletAfterMutation } from "../../utility/walletRefresh";

export const setGameData = (data) => {
  // console.log("dats----------------------->", data);
  return {
    type: SET_GAME_DATA,
    data: data,
  };
};

export const setOddsData = (data, message) => {
  // console.log("setOddsDatasetOddsData", data);
  return {
    type: SET_ODDS_DATA,
    data: data,
    message: message,
  };
};
export const getGamedata = async (data, dispatch) => {
  try {
    // This endpoint returns the leagues for a single sport group, so a valid
    // `game` group is mandatory. Guard against bad callers (e.g. passing the
    // dispatch fn) to avoid firing a request that always 400s.
    const game = data && typeof data === "object" ? data.game : undefined;
    if (!game) {
      return {
        status: false,
        message: "Game group is required",
        result: [],
      };
    }

    let respData = await axios({
      url: key.API_URL + api.getGamedata,
      method: "post",
      data: { game },
    });
    console.log('respData res', respData)
    // dispatch(setGameData(respData?.data?.result));
    // console.log(respData?.data?.result, "respData?.data?.result");
    return {
      status: respData?.data?.status,
      message: respData?.data?.message,
      result: respData?.data?.result,
    };
  } catch (err) {
    console.log('respData err', err)
    // console.log(err, "getGamedata_error");
    return {
      status: err?.response?.data?.status,
      message: err?.response?.data?.message,
      error: err?.response?.data?.errors,
    };
  }
};

export const getGamedatas = async (dispatch) => {
  try {
    let respData = await axios({
      url: key.API_URL + api.getGamedatas,
      method: "post",
    });
    dispatch(setGameData(respData?.data?.result));
    // console.log(respData?.data?.result, "respData?.data?.result");
    return {
      status: respData?.data?.status,
      message: respData?.data?.message,
      result: respData?.data?.result,
    };
  } catch (err) {
    // console.log(err, "getGamedata_error");
    return {
      status: err?.response?.data?.status,
      message: err?.response?.data?.message,
      error: err?.response?.data?.errors,
    };
  }
};

export const getOddsListnextItems = async (data,page=1) => {
  try {
    console.log("pagedata", data,page)
    console.log("URL", key.API_URL + api.getsportListnextPage)
    const respData = await axios({
      url: key.API_URL + api.getsportListnextPage,
      method: "post",
      params: { page }, // ✅ send as query params
      data: data, // optional, or any body you need
    });
    return {
      status: respData?.data?.status,
      message: respData?.data?.message,
      result: respData?.data?.result,
      meta: respData?.data?.meta,
    };
  } catch (err) {
    console.log(err, err?.response?.data?.message, "getGamedata_error");
    return {
      status: err?.response?.data?.status,
      message: err?.response?.data?.message,
      error: err?.response?.data?.errors,
    };
  }
};

export const getOddsList = async (data, dispatch,page=1) => {
  try {
    console.log("pagedata", data,page)
    console.log("URL", key.API_URL + api.getSportsOddList)
    const respData = await axios({
      url: key.API_URL + api.getSportsOddList,
      method: "post",
      params: { page }, // ✅ send as query params
      data: data, // optional, or any body you need
    });

    console.log("URL", key.API_URL + api.getSportsOddList, respData)
    dispatch(setOddsData(respData?.data?.result, ""));
    return {
      status: respData?.data?.status,
      message: respData?.data?.message,
      result: respData?.data?.result,
      meta: respData?.data?.meta,
    };
  } catch (err) {
    console.log(err, err?.response?.data?.message, "getGamedata_error");
    dispatch(setOddsData([], err?.response?.data?.message));
    return {
      status: err?.response?.data?.status,
      message: err?.response?.data?.message,
      error: err?.response?.data?.errors,
    };
  }
};

export const getLiveOddsList = async () => {
  try {
    console.log("URLgetLiveOddsList", key.API_URL + api.getLiveOddsList)
    const respData = await axios({
      url: key.API_URL + api.getLiveOddsList,
      method: "get",
    });
    return {
      status: respData?.data?.status,
      message: respData?.data?.message,
      result: respData?.data?.result,
    };
  } catch (err) {
    console.log(err, err?.response?.data?.message, "getGamedata_error");
    return {
      status: err?.response?.data?.status,
      message: err?.response?.data?.message,
      error: err?.response?.data?.errors,
    };
  }
};

export const getOpenBetBoardGame = async (data) => {
  try {
    const respData = await axios({
      url: key.API_URL + api.getOpenBetBoardGame,
      method: "post",
      data,
    });
    return {
      status: respData?.data?.status,
      message: respData?.data?.message,
      result: respData?.data?.result,
    };
  } catch (err) {
    return {
      status: err?.response?.data?.status,
      message: err?.response?.data?.message,
      error: err?.response?.data?.errors,
    };
  }
};
export const addOrder = async (data) => {
  try {
    let respData = await axios({
      url: key.API_URL + api.addbetOrder,
      method: "post",
      data: data,
    });
    // console.log("sportData", respData.data.data);
    return refreshWalletAfterMutation({
      status: respData?.data?.status,
      message: respData?.data?.message,
      result: respData?.data?.data,
    });
  } catch (err) {
    // console.log(err, "sportData_error");
    return {
      status: err?.response?.data?.status,
      message: err?.response?.data?.message,
      error: err?.response?.data?.errors,
    };
  }
};

export const getAllOrders = async (data) => {
  // console.log(data, "datagetAllOrders");
  try {
    let respData = await axios({
      url: key.API_URL + api.getbetOrder,
      method: "post",
      data: data,
    });

    // console.log(respData, "respDatarespDatarespData");
    return {
      status: respData?.data?.status,
      message: respData?.data?.message,
      result: respData?.data?.result,
    };
  } catch (err) {
    // console.log(err, "getAllOrders_error");
    return {
      status: err?.response?.data?.status,
      message: err?.response?.data?.message,
      error: err?.response?.data?.errors,
    };
  }
};

export const getBetCashoutQuote = async (data) => {
  try {
    const respData = await axios({
      url: key.API_URL + api.getBetCashoutQuote,
      method: "post",
      data,
    });
    return {
      status: respData?.data?.status,
      message: respData?.data?.message,
      result: respData?.data?.result,
      cashoutAvailable: respData?.data?.cashoutAvailable,
    };
  } catch (err) {
    return {
      status: err?.response?.data?.status,
      message: err?.response?.data?.message,
      cashoutAvailable: err?.response?.data?.cashoutAvailable,
    };
  }
};

export const executeBetCashout = async (data) => {
  try {
    const respData = await axios({
      url: key.API_URL + api.executeBetCashout,
      method: "post",
      data,
    });
    return refreshWalletAfterMutation({
      status: respData?.data?.status,
      message: respData?.data?.message,
      result: respData?.data?.result,
    });
  } catch (err) {
    return {
      status: err?.response?.data?.status,
      message: err?.response?.data?.message,
    };
  }
};

export const getAllCallBetOrders = async (data) => {
  // console.log(data, "datagetAllOrders");
  try {
    let respData = await axios({
      url: key.API_URL + api.getCallbetOrder,
      method: "post",
      data: data,
    });

    console.log(respData, "getAllCallBetOrdersrespDatarespDatarespData");
    return {
      status: respData?.data?.status,
      message: respData?.data?.message,
      result: respData?.data?.result,
    };
  } catch (err) {
    // console.log(err, "getAllOrders_error");
    return {
      status: err?.response?.data?.status,
      message: err?.response?.data?.message,
      error: err?.response?.data?.errors,
    };
  }
};

export const getgameDetails = async (data) => {
  // console.log(data, "datagetAllOrders");
  try {
    let respData = await axios({
      url: key.API_URL + api.getGameDetails,
      method: "post",
      data: data,
    });

    console.log(respData, "getAllCallBetOrdersrespDatarespDatarespData");
    return {
      status: respData?.data?.status,
      message: respData?.data?.message,
      result: respData?.data?.result,
    };
  } catch (err) {
    // console.log(err, "getAllOrders_error");
    return {
      status: err?.response?.data?.status,
      message: err?.response?.data?.message,
      error: err?.response?.data?.errors,
    };
  }
};

export const updateCallbetDetails = async (data) => {
  // console.log(data, "datagetAllOrders");
  try {
    let respData = await axios({
      url: key.API_URL + api.updteorder,
      method: "post",
      data: data,
    });

    return {
      status: respData?.data?.status,
      message: respData?.data?.message,
      result: respData?.data?.result,
    };
  } catch (err) {
    // console.log(err, "getAllOrders_error");
    return {
      status: err?.response?.data?.status,
      message: err?.response?.data?.message,
      error: err?.response?.data?.errors,
    };
  }
};
export const cancelCallbetOrders = async (data) => {
  // console.log(data, "datagetAllOrders");
  try {
    let respData = await axios({
      url: key.API_URL + api.cancelorder,
      method: "post",
      data: data,
    });

    return {
      status: respData?.data?.status,
      message: respData?.data?.message,
      result: respData?.data?.result,
    };
  } catch (err) {
    // console.log(err, "getAllOrders_error");
    return {
      status: err?.response?.data?.status,
      message: err?.response?.data?.message,
      error: err?.response?.data?.errors,
    };
  }
};
export const getWalletDetails = async (data) => {
  if (!data?.email) {
    return { status: false, message: "Email is required" };
  }
  try {
    let respData = await axios({
      url: key.API_URL + api.getWallet,
      method: "post",
      data: data,
      validateStatus: (status) => status < 500,
    });

    // console.log(respData, "respDatarespDatarespData");
    return {
      status: respData?.data?.status,
      message: respData?.data?.message,
      result: respData?.data?.result,
    };
  } catch (err) {
    // console.log(err, "getAllOrders_error");
    return {
      status: err?.response?.data?.status,
      message: err?.response?.data?.message,
      error: err?.response?.data?.errors,
    };
  }
};

export const getbetHistoryData = async (data) => {
  // console.log(data, "datagetAllOrders");
  try {
    let respData = await axios({
      url: key.API_URL + api.getbetHistory,
      method: "post",
      data: data,
    });

    // console.log(respData, "respDatarespDatarespData");
    return {
      status: respData?.data?.status,
      message: respData?.data?.message,
      result: respData?.data?.result,
    };
  } catch (err) {
    // console.log(err, "getAllOrders_error");
    return {
      status: err?.response?.data?.status,
      message: err?.response?.data?.message,
      error: err?.response?.data?.errors,
    };
  }
};

export const getLiveOdds = async () => {
  try {
    let respData = await axios({
      url: key.API_URL + api.getLiveOdds,
      method: "post",
      // data: data,
    });

    return {
      status: respData?.data?.status,
      message: respData?.data?.message,
      result: respData?.data?.result,
    };
  } catch (err) {
    return {
      status: err?.response?.data?.status,
      message: err?.response?.data?.message,
      error: err?.response?.data?.errors,
    };
  }
};

export const getParlayOrders = async (data) => {
  // console.log(data, "datagetAllOrders");
  try {
    let respData = await axios({
      url: key.API_URL + api.getParlayBettingOrders,
      method: "post",
      data: data,
    });

    // console.log(respData, "respDatarespDatarespData");
    return {
      status: respData?.data?.status,
      message: respData?.data?.message,
      result: respData?.data?.result,
    };
  } catch (err) {
    // console.log(err, "getAllOrders_error");
    return {
      status: err?.response?.data?.status,
      message: err?.response?.data?.message,
      error: err?.response?.data?.errors,
    };
  }
};

export const getParlayOpenSpots = async (data) => {
  // console.log(data, "datagetAllOrders");
  try {
    let respData = await axios({
      url: key.API_URL + api.getAllOpenSpots,
      method: "post",
      data: data,
    });

    // console.log(respData, "respDatarespDatarespData");
    return {
      status: respData?.data?.status,
      message: respData?.data?.message,
      result: respData?.data?.result,
    };
  } catch (err) {
    // console.log(err, "getAllOrders_error");
    return {
      status: err?.response?.data?.status,
      message: err?.response?.data?.message,
      error: err?.response?.data?.errors,
    };
  }
};

export const getSingleOpenSpots = async (data) => {
  if (!data?._id) {
    return { status: false, message: "Order id is required" };
  }
  try {
    let respData = await axios({
      url: key.API_URL + api.getOneOpenSpots,
      method: "post",
      data: data,
      validateStatus: (status) => status < 500,
    });

    console.log(respData, "respDatarespDatarespData");
    return {
      status: respData?.data?.status,
      message: respData?.data?.message,
      result: respData?.data?.result,
    };
  } catch (err) {
    // console.log(err, "getAllOrders_error");
    return {
      status: err?.response?.data?.status,
      message: err?.response?.data?.message,
      error: err?.response?.data?.errors,
    };
  }
};

export const fillOpenSpots = async (data) => {
  // console.log(data, "datagetAllOrders");
  try {
    let respData = await axios({
      url: key.API_URL + api.addOpenSpots,
      method: "post",
      data: data,
    });

    // console.log(respData, "respDatarespDatarespData");
    return refreshWalletAfterMutation({
      status: respData?.data?.status,
      message: respData?.data?.message,
      result: respData?.data?.result,
    });
  } catch (err) {
    // console.log(err, "getAllOrders_error");
    return {
      status: err?.response?.data?.status,
      message: err?.response?.data?.message,
      error: err?.response?.data?.errors,
    };
  }
};

export const getPointGames = async (data) => {
  // console.log(data, "datagetAllOrders");
  try {
    let respData = await axios({
      url: key.API_URL + api.getPointsGames,
      method: "post",
      data: data,
    });

    console.log("respDatarespDatarespData", key.API_URL + api.getPointsGames, respData,);
    return {
      status: respData?.data?.status,
      message: respData?.data?.message,
      result: respData?.data?.result,
    };
  } catch (err) {
    // console.log(err, "getAllOrders_error");
    return {
      status: err?.response?.data?.status,
      message: err?.response?.data?.message,
      result: err?.response?.data?.result,
      error: err?.response?.data?.errors,
    };
  }
};

export const setFavsport = async (data, dispatch) => {
  try {
    console.log("page", data)
    console.log("URL", key.API_URL + api.setFavGamelist)
    const respData = await axios({
      url: key.API_URL + api.setFavGamelist,
      method: "post",
      // params: { page }, // ✅ send as query params
      data: data, // optional, or any body you need
    });

    
    // dispatch(setOddsData(respData?.data?.result, ""));
    return {
      status: respData?.data?.status,
      message: respData?.data?.message,
      result: respData?.data?.result,
    };
  } catch (err) {
    console.log(err, err?.response?.data?.message, "sertfav_error");
    // dispatch(setOddsData([], err?.response?.data?.message));
    return {
      status: err?.response?.data?.status,
      message: err?.response?.data?.message,
      error: err?.response?.data?.errors,
    };
  }
};
export const getFavsport = async () => {
  try {
    const respData = await axios({
      url: key.API_URL + api.getFavGamelist,
      method: "get",
      // params: { page }, // ✅ send as query params
      // data: data, // optional, or any body you need
    });
    
    // dispatch(setOddsData(respData?.data?.result, ""));
    return {
      status: respData?.data?.status,
      message: respData?.data?.message,
      result: respData?.data?.result,
    };
  } catch (err) {
    console.log(err, err?.response?.data?.message, "sertfav_error");
    // dispatch(setOddsData([], err?.response?.data?.message));
    return {
      status: err?.response?.data?.status,
      message: err?.response?.data?.message,
      error: err?.response?.data?.errors,
    };
  }
};
